// src/components/AIChatToolIndicator.jsx
// While the agent is calling a tool, show three pulsing dots + tool label.
// On completion, show a brief check + label before the parent unmounts.

import React from 'react';

const TOOL_LABELS = {
  get_lead: '📍 Fetching lead data',
  list_leads: '📋 Listing leads',
  get_project: '🏗️ Fetching project data',
  list_projects: '📋 Listing projects',
  get_portfolio_deal: '💰 Fetching portfolio deal',
  list_portfolio: '📊 Listing portfolio',
  get_expenses: '💳 Fetching expenses',
  get_user_profile: '👤 Loading profile',
  calculate_flip_analysis: '📊 Calculating flip analysis',
  calculate_brrrr_analysis: '📊 Calculating BRRRR analysis',
  calculate_project_financials: '📊 Calculating financials',
  calculate_mao: '🎯 Calculating MAO',
  calculate_lead_profit_roi: '📈 Calculating ROI',
  web_search: '🔍 Searching the web',
};

export default function AIChatToolIndicator({ tool, done }) {
  const label = TOOL_LABELS[tool] || '⚙️ Processing';

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-full text-xs border self-start
      ${
        done
          ? 'border-emerald-500/30 text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-500/5'
          : 'border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800/60'
      }`}
    >
      {done ? (
        <span className="text-emerald-600 dark:text-emerald-400 leading-none">✓</span>
      ) : (
        <span className="inline-flex items-center gap-1" aria-hidden="true">
          <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 dark:bg-indigo-400 animate-bounce [animation-delay:0ms]" />
          <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 dark:bg-indigo-400 animate-bounce [animation-delay:150ms]" />
          <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 dark:bg-indigo-400 animate-bounce [animation-delay:300ms]" />
        </span>
      )}
      <span>{done ? label.replace(/^.+?\s/, '✓ ') : label.replace(/^.+?\s/, '')}</span>
    </div>
  );
}
